exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-square-loading-save[data-v-6bc2f7f1],.btn.loading.btn-square-loading-save[data-v-6bc2f7f1]{width:38px;height:35px;padding-right:.75rem!important;text-align:center}.btn-square-loading-save .loadingSpinner[data-v-6bc2f7f1],.btn.loading.btn-square-loading-save .loadingSpinner[data-v-6bc2f7f1]{margin-left:-10px;left:auto;right:auto}.form-control[data-v-6bc2f7f1]{padding-right:12px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bc2f7f1","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/attendance/show/Holidays.vue
// module id = xJXX
// module chunks = 0